// theme.js — minimal theme JS. Quantity steppers + variant pill toggles.
(function () {
  // Quantity steppers
  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-qty]");
    if (!btn) return;
    var wrap = btn.parentElement;
    var input = wrap.querySelector('input[type="number"]');
    if (!input) return;
    var v = parseInt(input.value, 10) || 1;
    v = btn.dataset.qty === "inc" ? v + 1 : Math.max(parseInt(input.min || 1, 10), v - 1);
    input.value = v;
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });

  // Option pill — radio mirror
  document.addEventListener("change", function (e) {
    if (e.target.matches('.pdp__opt-pill input[type="radio"]')) {
      var pills = e.target.closest(".pdp__opt-row").querySelectorAll(".pdp__opt-pill");
      pills.forEach(function (p) {
        p.classList.toggle("is-on", p.contains(e.target));
      });
    }
  });
})();
